import { render, staticRenderFns } from "./DataInternet.vue?vue&type=template&id=67d0a73d&scoped=true&"
import script from "./DataInternet.vue?vue&type=script&lang=js&"
export * from "./DataInternet.vue?vue&type=script&lang=js&"
import style0 from "./DataInternet.vue?vue&type=style&index=0&id=67d0a73d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d0a73d",
  null
  
)

export default component.exports